import { render, staticRenderFns } from "./TextareaWithAudio.vue?vue&type=template&id=614d8dec&scoped=true"
import script from "./TextareaWithAudio.vue?vue&type=script&lang=js"
export * from "./TextareaWithAudio.vue?vue&type=script&lang=js"
import style0 from "./TextareaWithAudio.vue?vue&type=style&index=0&id=614d8dec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614d8dec",
  null
  
)

export default component.exports